export default __webpack_public_path__ + "static/media/mobiles.5689b8d7.jpg";